<template>
  <div class="page-container insurance-product-manage">
    <div class="search">
      <div class="search-l">
        <el-button
          @click="handleSearchBtn(i)"
          v-for="(item, i) in searchBtnList"
          :key="item.name"
          :type="i === searchBtnActive ? 'primary' : 'text'"
        >
          {{ item.name }}
        </el-button>
        <el-date-picker
          class="ml20"
          v-model="dateRange"
          @change="searchModule(dateRange[0], dateRange[1])"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div class="search-r">
        <el-button
          type="text"
          size="medium"
          icon="el-icon-download"
          @click="dialogVisible = true"
        >
          下载数据
        </el-button>
      </div>
    </div>
    <div class="con">
       <h3 class="mgtd0 pdtd20 pdl20">图表分析</h3>
      <div class="card-wrap">
        <div
          class="card-item el-col el-col-11"
          v-for="(item, i) in list"
          :key="i"
        >
          <div class="fs12 card-item-head">{{ item.moduleName }}</div>
          <line-chart :data="item.dayVisits" />
        </div>
      </div>
      <ts-table
        ref="tsTable"
        :table-data="tableData"
        :table-head="tableHead"
        :table-title-obj="tableTitleObj"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @on-handle-filter="handleFilter"
      />
    </div>
    <download-dialog :dialogVisible="dialogVisible" @on-close="handleClose" />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import DownloadDialog from './components/download.vue'
import {
  visitModuleAll,
  tenantModuleList,
  tenantTable,
} from '@/api/dataObservation'
import { dateFormat, minToFormatDate } from '@/utils/baseFn'
import lineChart from './components/line.vue'
import TsTable from '@/components/TsTable/TsTable.vue'
@Component({
  components: {
    DownloadDialog,
    lineChart,
    TsTable,
  },
})
export default class extends Vue {
  dialogVisible = false;
  dateRange = [];
  searchBtnList = [
    {
      name: '今日',
      value: 1,
    },
    {
      name: '近七天',
      value: 7,
    },
    {
      name: '近一月',
      value: 30,
    },
    {
      name: '近一年',
      value: 365,
    },
  ];

  searchBtnActive = 1;

  list = [];

  resModule = [];

  tableData = {
    data: [],
    currentPage: 0,
    pageSize: 10,
    total: 0,
  };

  searchObj = {};

  tableHead = [];
  tableTitleObj = {
    title: '综合统计',
  };

  async created () {
    await this.getModule()
    await this.getTable()
  }

  async getModule () {
    const resModule = await tenantModuleList()
    if (resModule?.data) {
      this.resModule = resModule.data
    }
  }

  async getTable () {
    const { resModule, tableData } = this
    if (resModule.length) {
      const res = await tenantTable({
        page: tableData.currentPage,
        size: tableData.pageSize,
        ...this.searchObj,
      })
      if (res?.data?.content) {
        const _list = []
        if (res.data.content.length > 0) {
          const firstTableMap = res.data.content[0]
          const _objHead = [
            {
              propName: 'userName',
              labelName: '姓名',
              options: {
                type: 'search',
              },
            },
            {
              propName: 'visitSecond',
              labelName: '总访问时长',
            },
          ]
          for (const k in firstTableMap.secondMap) {
            const moduleMap = this.resModule.find((w) => w.moduleCode === k)
            if (moduleMap) {
              _objHead.push({
                propName: moduleMap.moduleCode,
                labelName: moduleMap.moduleName,
              })
            }
          }
          _objHead.push(
            {
              propName: '16',
              labelName: '报告生成',
              options: {
                type: 'sort',
                optionArr: [
                  {
                    type: 'asc',
                    name: '升序',
                    icon: 'el-icon-top',
                  },
                  {
                    type: 'desc',
                    name: '降序',
                    icon: 'el-icon-bottom',
                  },
                ],
              },
            },
            {
              propName: '01',
              labelName: '登录次数',
              options: {
                type: 'sort',
                optionArr: [
                  {
                    type: 'asc',
                    name: '升序',
                    icon: 'el-icon-top',
                  },
                  {
                    type: 'desc',
                    name: '降序',
                    icon: 'el-icon-bottom',
                  },
                ],
              },
            }
          )
          res.data.content.forEach((item) => {
            const { userName, visitSecond, secondMap, countMap } = item

            const _obj = {
              userName,
              visitSecond: minToFormatDate(visitSecond),
            }
            for (const k in secondMap) {
              _obj[k] = minToFormatDate(secondMap[k])
            }

            _obj['01'] = countMap['01']
            _obj['16'] = countMap['16']
            _list.push(_obj)
          })
          this.tableHead = _objHead
          this.tableData.data = _list
          this.tableData.total = res.data.totalElements
        }
        this.tableData.data = _list
        this.tableData.total = res.data.totalElements
      }
    }
  }

  mounted () {
    this.searchModule(this.oldTime(), new Date())
  }

  oldTime () {
    return new Date(
      +new Date() -
        this.searchBtnList[this.searchBtnActive].value * 1000 * 60 * 60 * 24
    )
  }

  handleSearchBtn (idx) {
    this.searchBtnActive = idx
    this.dateRange = []
    this.searchModule(this.oldTime(), new Date())
  }

  handleClose () {
    this.dialogVisible = false
  }

  async searchModule (startTime, endTime) {
    const res = await visitModuleAll({
      startDate: dateFormat(startTime, 'YYYY-MM-DD'),
      endDate: dateFormat(endTime, 'YYYY-MM-DD'),
    })
    if (this.resModule.length && res.data) {
      const moduleList = this.resModule
      const cardModuleList = res.data
      const _list = []
      cardModuleList.forEach((item, idx) => {
        const _obj = {
          moduleCode: item.moduleCode,
          moduleName: moduleList[idx].moduleName,
          dayVisits: [],
        }
        item.dayVisits.forEach((v) => {
          if (moduleList[idx].pv) {
            _obj.dayVisits.push({
              x: v.localDate,
              y: v.pv,
              alias: '访问人次',
            })
          }
          if (moduleList[idx].uv) {
            _obj.dayVisits.push({
              x: v.localDate,
              y: v.uv,
              alias: '访问人数',
            })
          }
        })
        _list.push(_obj)
      })
      this.list = _list
    }
  }

  /**
   * handleFilter 过滤处理filter
   */
  handleFilter (tags) {
    const _obj = {}
    tags.forEach((item) => {
      const { params, type: itemType } = item
      const { head, opt } = params
      const { type } = head.options
      const { value } = opt

      if (type === 'search') {
        _obj.userName = value
      } else if (type === 'sort') {
        _obj.sortField = itemType
        _obj.direction = opt.type
      }
    })
    this.searchObj = _obj
    this.getTable()
  }

  // 分页相关
  // 选择条数
  handleSizeChange (val) {
    this.tableData.pageSize = val
    this.getTable()
  }

  // 当前第几页
  handleCurrentChange (val) {
    this.tableData.currentPage = val
    this.getTable()
  }
}
</script>
<style lang="scss">
</style>
<style lang="scss" scoped>
.search {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: $fff;
  padding: 16px 15px;
  margin-bottom: 20px;
}
.card-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  .card-item {
    border-radius: 4px;
    background-color: $fff;
    margin-bottom: 15px;
    .card-item-head {
      padding: 12px 15px;
      border-bottom: 1px solid #d7d7d7;
    }
  }
}
</style>
